'use client'

import { dayOptions } from '@/helpers/days'
import { buildSearchParamsObject } from '@/lib/server/sim-racing-games/schemas'
import PublicSearchForm from './public-search-form'
import { pickerOptions } from './search-filter-helpers'

export default function GameDiscoverySearchForm({
  game,
  appliedFilter,
  mode = 'racing',
}) {
  const fields = [
    {
      key: 'platforms',
      label: 'Platform',
      multi: true,
      options: pickerOptions(game.platforms.map((entry) => entry.platform)),
    },
  ]
  if (mode === 'racing')
    fields.push(
      {
        key: 'raceTypes',
        label: 'Race type',
        multi: true,
        options: [
          { value: 'single', label: 'Single Event' },
          { value: 'championship', label: 'Championship Event' },
        ],
      },
      {
        key: 'carClasses',
        label: 'Car classes',
        multi: true,
        searchable: 'long',
        options: pickerOptions(game.carClasses, { labelKey: 'name' }),
      },
      {
        key: 'sort',
        label: 'Sort by',
        defaultValue: 'live',
        options: [
          { value: 'live', label: 'Live' },
          { value: 'upcoming', label: 'Upcoming' },
          { value: 'finished', label: 'Finished' },
        ],
      },
    )
  if (mode !== 'liveries')
    fields.push({
      key: 'days',
      label: 'Race days',
      multi: true,
      options: pickerOptions(dayOptions, { days: true }),
    })
  else
    fields.push({
      key: 'cars',
      label: 'Cars',
      multi: true,
      searchable: 'long',
      options: pickerOptions(
        game.carClasses.flatMap((entry) => entry.cars || []),
        { labelKey: 'name' },
      ),
    })
  fields.push({ key: 'q', kind: 'text', label: 'Keyword', maxLength: 80 })
  return (
    <PublicSearchForm
      fields={fields}
      applied={appliedFilter}
      encode={buildSearchParamsObject}
      keywordPlaceholder={`Search ${mode}`}
      className="col-span-full mt-6 desktop-xs:col-span-10 desktop-xs:col-start-2"
    />
  )
}
